const supportedComponentAPIs = {
    'wysiwyg.viewer.components.BoxSlideShow': [
        'onPlay',
        'onPause',
        'play',
        'pause',
        'previous',
        'next',
        'isPlaying',
        'clickAction',
        'items',
        'onItemClicked',
        'animate',
        'clearAnimations'
    ],
    'wysiwyg.viewer.components.StripContainerSlideShow': [
        'onPlay',
        'onPause',
        'play',
        'pause',
        'previous',
        'next',
        'isPlaying',
        'clickAction',
        'items',
        'onItemClicked',
        'animate',
        'clearAnimations'
    ],
    'wysiwyg.viewer.components.SlideShowGallery': [
        'currentIndex',
        'currentItem',
        'showNavigationButtons',
        'onCurrentItemChanged',
        'onPlay',
        'onPause',
        'play',
        'pause',
        'previous',
        'next',
        'isPlaying',
        'clickAction',
        'items',
        'onItemClicked',
        'animate',
        'clearAnimations'
    ],
    'wysiwyg.viewer.components.SliderGallery': [
        'clickAction',
        'items',
        'onItemClicked',
        'animate',
        'clearAnimations'
    ],
    'wysiwyg.viewer.components.MatrixGallery': [
        'clickAction',
        'items',
        'onItemClicked',
        'animate',
        'clearAnimations'
    ],
    'wysiwyg.viewer.components.PaginatedGridGallery': [
        'showNavigationButtons',
        'onPlay',
        'onPause',
        'play',
        'pause',
        'previous',
        'next',
        'isPlaying',
        'clickAction',
        'items',
        'onItemClicked',
        'animate',
        'clearAnimations'
    ],
    'tpa.viewer.components.Collage': [
        'clickAction',
        'items',
        'onItemClicked'
    ],
    'tpa.viewer.components.Masonry': [
        'clickAction',
        'items',
        'onItemClicked'
    ],
    'tpa.viewer.components.Honeycomb': [
        'clickAction',
        'items',
        'onItemClicked'
    ],
    'tpa.viewer.components.Accordion': [
        'clickAction',
        'items',
        'onItemClicked'
    ],
    'tpa.viewer.components.Freestyle': [
        'clickAction',
        'items',
        'onItemClicked'
    ],
    'tpa.viewer.components.Thumbnails': [
        'currentIndex',
        'currentItem',
        'onCurrentItemChanged',
        'showNavigationButtons',
        'play',
        'pause',
        'previous',
        'next',
        'isPlaying',
        'clickAction',
        'items',
        'onItemClicked'
    ],
    'tpa.viewer.components.StripShowcase': [
        'currentIndex',
        'currentItem',
        'onCurrentItemChanged',
        'showNavigationButtons',
        'play',
        'pause',
        'previous',
        'next',
        'isPlaying',
        'clickAction',
        'items',
        'onItemClicked'
    ],
    'tpa.viewer.components.StripSlideshow': [
        'currentIndex',
        'currentItem',
        'onCurrentItemChanged',
        'play',
        'pause',
        'previous',
        'next',
        'isPlaying',
        'items',
        'onItemClicked'
    ],
    'wysiwyg.viewer.components.tpapps.TPA3DCarousel': [
        'currentIndex',
        'currentItem',
        'onCurrentItemChanged',
        'play',
        'pause',
        'previous',
        'next',
        'isPlaying',
        'clickAction',
        'items',
        'onItemClicked'
    ],
    'wysiwyg.viewer.components.tpapps.TPA3DGallery': [
        'currentIndex',
        'currentItem',
        'onCurrentItemChanged',
        'play',
        'pause',
        'previous',
        'next',
        'isPlaying',
        'clickAction',
        'items',
        'onItemClicked'
    ],
    'tpa.viewer.components.Impress': [
        'currentIndex',
        'currentItem',
        'onCurrentItemChanged',
        'play',
        'pause',
        'previous',
        'next',
        'isPlaying',
        'clickAction',
        'items',
        'onItemClicked'
    ]
};

/**
 * @typedef {Object} TypesData
 * @propery {Object} supportedComponentAPIs
 * @property {Object} viewerTypeToSdkTypeDefinitions
 */
export default {
    supportedComponentAPIs
};
